import axios from 'axios';

import {
  convertToSnakeCase,
  camelCaseKeysToUnderscore,
} from 'data_system/helpers/apiHelpers';

const experiencesApi = {
  fetchExperience(params) {
    return axios({
      method: 'get',
      url: `/api/resources/${params.resourceId}/experiences/${params.id}`,
    });
  },
  fetchExperiences(params) {
    return axios({
      method: 'get',
      url: `/api/resources/${params.resourceId}/experiences`,
      params,
    });
  },
  createExperience(params) {
    return axios({
      method: 'post',
      url: `/api/resources/${params.resourceId}/experiences`,
      params,
    });
  },
  updateExperience(attrs) {
    // Create a copy of attrs to re-case the keys to pass to backend
    const apiAttrs = JSON.parse(JSON.stringify(attrs));

    // compute the duration in seconds that is set on tour, and add it to availability rules
    // let duration = computeDuration(apiAttrs.lengthType, apiAttrs.length);
    // (apiAttrs.availabilityRulesAttributes || []).forEach(rule => {
    //   rule.duration = duration;
    // });
    camelCaseKeysToUnderscore(apiAttrs);
    // ==

    const params = apiAttrs;

    return axios({
      method: 'patch',
      url: `/api/resources/${apiAttrs.resource_id}/experiences/${apiAttrs.id}`,
      data: params,
    }).catch((error) => {
      throw new Error(error?.response?.data?.message);
    });
  },

  createExperienceMeetingInfo(attrs) {
    const params = JSON.parse(JSON.stringify(attrs));
    camelCaseKeysToUnderscore(params);
    return axios({
      method: 'post',
      url: `/api/resource_portal/meetings`,
      data: params,
    }).catch((error) => {
      throw new Error(error?.response?.data?.message);
    });
  },

  updateExperienceMeetingInfo(attrs) {
    const params = JSON.parse(JSON.stringify(attrs));
    camelCaseKeysToUnderscore(params);
    return axios({
      method: 'patch',
      url: `/api/resource_portal/meetings/${params.id}`,
      data: params,
    }).catch((error) => {
      throw new Error(error?.response?.data?.message);
    });
  },

  createPhoto(attrs) {
    const url = `/api/resources/${attrs.resource_id}/experiences/${attrs.experience_id}/assets`;

    return axios({
      method: 'post',
      url,
      data: attrs,
    });
  },

  removePhoto(attrs) {
    const url = `/api/resources/${attrs.resourceId}/experiences/${attrs.experienceId}/assets/${attrs.assetId}`;
    return axios({
      method: 'delete',
      url,
    });
  },

  repositionPhoto(attrs) {
    const url = `/api/resources/${attrs.resourceId}/experiences/${attrs.experienceId}/assets/${attrs.assetId}/move`;
    return axios({
      method: 'put',
      url,
      data: {
        position: attrs.position,
      },
    });
  },

  fetchAvailability({ resourceId, experienceId, ...params }) {
    return axios({
      method: 'get',
      url: `/api/resource_portal/resources/${resourceId}/experiences/${experienceId}/schedule`,
      params,
    });
  },

  saveSchedule({ resourceId, experienceId, ...params }) {
    return axios({
      method: 'put',
      url: `/api/resource_portal/resources/${resourceId}/experiences/${experienceId}/update_schedule`,
      params,
    });
  },
};

export default experiencesApi;
